window.$ = window.jQuery;

class MultistepForm {
  constructor() {
    this.query = [];
    this.totalQuestion = +$(".multistep-attribute").data("total");
    this.updateDomVariables();
    this.back = $(".multistep-attribute__back");

    this.lang = window.ortica.lang;

    this.events();
  }

  events() {
    $(".multistep-attribute__reset-btn").on("click", this.reset.bind(this));

    $(".multistep-attribute .multistep-attribute__button").on("click", (e) => {
      $(e.currentTarget).toggleClass("multistep-attribute__button--selected");
    });

    $(".multistep-attribute .multistep-attribute__show-result").on(
      "click",
      this.showResult.bind(this)
    );

    $(".multistep-attribute .multistep-attribute__confirm").on(
      "click",
      this.confirm.bind(this)
    );
    this.back.on("click", async () => {
      const prev = this.getPrev();
      this.query[prev] = {};

      let buttons = $(
        `.multistep-attribute__content-${prev} .multistep-attribute__button`
      );

      buttons.each((index, btn) => {
        $(btn).removeClass("multistep-attribute__button--selected");
      });

      buttons = $(
        `.multistep-attribute__content-${this.activeIndex} .multistep-attribute__button`
      );

      buttons.each((index, btn) => {
        $(btn).removeClass("multistep-attribute__button--selected");
      });

      this.save();

      const resp = await this.checkSelected(this.getQueryString());

      this.toggleButton(resp, prev);
      this.goTo(prev);
    });
  }

  getQueryString() {
    const obj = this.query.reduce((acc, next) => {
      for (let key in next) {
        if (!acc[key]) acc[key] = [];

        next[key].forEach((value) => {
          if (!acc[key].includes(value)) {
            acc[key].push(value);
          }
        });
      }

      return acc;
    }, {});

    return Object.entries(obj)
      .map(([key, values]) => `${key}=${values.join(",")}`)
      .join("&");
  }

  getUrl() {
    var lang = window.ortica.lang != "it" ? `/${window.ortica.lang}/` : "";

    return `${
      window.location.origin
    }${lang}?${this.getQueryString()}&from_configurator=1`;
  }

  showResult(e) {
    e.preventDefault();

    if (!this.save()) {
      return alert(window.ortica.alert);
    }

    window.location.href = this.getUrl();
  }

  async confirm(e) {
    e.preventDefault();

    if (!this.save()) {
      alert(window.ortica.alert);
      return;
    }

    if (this.hasNext()) {
      const resp = await this.checkSelected(this.getQueryString());
      const next = this.getNext();

      this.toggleButton(resp, next);
      this.goTo(next);
      // this.maybeShowResetBtn(next);
    }
  }

  toggleButton({ data }, nextIndex) {
    const buttons = $(
      `.multistep-attribute__content-${nextIndex} .multistep-attribute__button`
    );

    if (buttons) {
      buttons.each((index, btn) => {
        const [attributeName, attributeValue] = $(btn)
          .data("attribute")
          .split("=");

        if (data[attributeName].terms[attributeValue].active) {
          $(btn).removeClass("multistep-attribute__button--disabled");
        } else {
          $(btn).addClass("multistep-attribute__button--disabled");
        }
      });
    }
  }

  async checkSelected(query) {
    const url =
      this.lang !== "it"
        ? `/${this.lang}/?wc-ajax=configurator&${query}`
        : `/?wc-ajax=configurator&${query}`;

    return jQuery.ajax({ url });
  }

  save() {
    const targets = $(
      `.multistep-attribute__content-${this.activeIndex} .multistep-attribute__button--selected`
    );

    this.query[this.activeIndex] = {};

    targets.each((index, target) => {
      const query = $(target).data("attribute");
      const parts = query.split("&");

      // Save query from current index button
      parts.map((part) => {
        const [attribute, values] = part.split("=");

        if (!this.query[this.activeIndex][attribute]) {
          this.query[this.activeIndex][attribute] = [];
        }

        values.split(",").forEach((val) => {
          if (!this.query[this.activeIndex][attribute].includes(val)) {
            this.query[this.activeIndex][attribute].push(val);
          }
        });
      });
    });

    return !!targets.length;
  }

  updateDomVariables() {
    this.activeNumber = $(".multistep-attribute__number--active");
    this.activeContent = $(".multistep-attribute__content--active");

    this.activeIndex = +this.activeNumber.data("index");
  }

  goTo(index) {
    const nextNumber = $(`.multistep-attribute__number[data-index=${index}]`);
    const nextContent = $(`.multistep-attribute__content[data-index=${index}]`);

    this.activeContent.animate(
      {
        opacity: 0,
      },
      300,
      () => {
        this.activeContent.removeClass("multistep-attribute__content--active");
        this.activeNumber.removeClass("multistep-attribute__number--active");

        nextContent.css("opacity", 0);

        nextContent.animate(
          {
            opacity: 1,
          },
          300
        );
        nextContent.addClass("multistep-attribute__content--active");
        nextNumber.addClass("multistep-attribute__number--active");

        this.updateDomVariables();
        this.maybeShowArrow();
      }
    );
  }

  maybeShowArrow() {
    if (this.hasPrev()) {
      this.back.removeClass("hidden");
    } else {
      this.back.addClass("hidden");
    }
  }

  reset() {
    this.activeIndex = 0;
    this.query = [];

    // Remove active class for all the btn
    $(".multistep-attribute .multistep-attribute__button").removeClass(
      "multistep-attribute__button--selected"
    );

    this.goTo(0);
    this.updateDomVariables();
  }

  // maybeShowResetBtn(index) {
  //   const className = "multistep-attribute__reset--disable";
  //   const action = index > 0 ? "removeClass" : "addClass";

  //   console.log(this.activeIndex);
  //   $(".multistep-attribute__reset")[action](className);
  // }

  hasNext() {
    return this.activeIndex < this.totalQuestion;
  }

  hasPrev() {
    return this.activeIndex > 0;
  }

  getNext() {
    return this.activeIndex + 1 <= this.totalQuestion
      ? this.activeIndex + 1
      : this.totalQuestion;
  }

  getPrev() {
    return this.activeIndex - 1 >= 0 ? this.activeIndex - 1 : 0;
  }
}

new MultistepForm();
